<template>
	<PosListQromo @save-settings="clickSaveSettings" @delete-terminal="v => $emit('delete-terminal', v)" />
	<PosListDojo @save-settings="clickSaveDojoSettings" @delete-terminal="v => $emit('delete-dojo-terminal', v)" />
	<PosListPax v-if="TEST" @save-settings="clickSavePaxSettings" @delete-terminal="v => $emit('delete-pax-terminal', v)" />
</template>

<script>
import AppList from "@/shared/components/AppList.vue";
import AppCard from "@/shared/components/AppCard.vue";
import AppTextInput from "@/shared/components/AppTextInput.vue";
import AppSwitch from "@/shared/components/AppSwitch.vue";
import AppButton from "@/shared/components/AppButton.vue";
import AppSelect from "@/shared/components/AppSelect.vue";
import AppChecklist from "@/shared/components/AppChecklist.vue";
import AppChevronIcon from "@/shared/components/AppChevronIcon.vue";
import AvailabilityDot from "@/console-new/components/config/menu/AvailabilityDot.vue";
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";

import {useLanguageStore, useNotificationStore, useSvgStore} from "@/shared/stores";
import {useRoomsStore, useUserStore} from "@/console-new/stores";
import TerminalTipsSettings from "@/console-new/components/plugins/TerminalTipsSettings.vue";
import WindowWidth from "@/console-new/mixins/WindowWidth";
import PosListQromo from "@/console-new/components/plugins/PosListQromo.vue";
import PosListPax from "@/console-new/components/plugins/PosListPax.vue";
import PosListDojo from "@/console-new/components/plugins/PosListDojo.vue";


export default {
	setup() {
		let languageStore = useLanguageStore();
		let notificationStore = useNotificationStore();
		let userStore = useUserStore();
		let roomsStore = useRoomsStore();
		const svgStore = useSvgStore();
		return {getString: languageStore.getString, showNotification: notificationStore.showNotification, userStore, roomsStore, getIcon: svgStore.get};
	},
	name: "PosSettingsCard",
	emits: ["save-settings","save-dojo-settings","save-pax-settings","delete-terminal","delete-pax-terminal","delete-dojo-terminal"],
	components: {
		PosListPax,
		PosListDojo,
		TerminalTipsSettings, AppSelect, AppChecklist, AppList, AppCard, AppTextInput, AppButton, AvailabilityDot, AppChevronIcon, AppSwitch, AppBottomSheet, PosListQromo
	},
	mixins: [WindowWidth],
	data(){
		return {
			terminalIdForTips: null,
			TEST: TEST,
		}
	},
	computed: {
	},
	methods: {
		clickSaveSettings(newTerminalData, callback) {
			this.$emit('save-settings', newTerminalData, callback);
		},
		clickSavePaxSettings(newTerminalData, callback) {
			this.$emit('save-pax-settings', newTerminalData, callback);
		},
		clickSaveDojoSettings(newTerminalData, callback) {
			this.$emit('save-dojo-settings', newTerminalData, callback);
		},
	},
}
</script>

<style lang="scss" scoped>
</style>